import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      backgroundColor: COLORS.primary.silver,
      color: COLORS.neutral.darkGray,
      padding: theme.spacing(0.375, 1),
      borderRadius: theme.shape.borderRadiusSemiLarge,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(10),
      fontWeight: theme.typography.fontWeightNormal,
      textAlign: 'left',
      height: 'auto',
      '&$disabled': {
        backgroundColor: COLORS.gray.gray80,
      },
    },
    disabled: {},
  }),
  { name: 'BrandVoiceLanguageTag' }
);
